import { createAction, props } from "@ngrx/store";
import { IBaseSearchRequest } from "src/app/core/models/base";
import { ICreateDeviceRequest, IDeviceDetailsResponse, IUpdateDeviceRequest } from "src/app/devices/models/device";
import { ImportStatusEnum } from "src/app/history/models/import";

// Get Devices 
export const getDevices = createAction(
    '[Devices] Get Devices '
);

export const getDevicesSuccess = createAction(
    '[Devices] Get Devices success', 
    props<{ devices: IDeviceDetailsResponse[] }>()
);

export const getDevicesFailure = createAction(
    '[Devices] Get Devices failure',
    props<{error: string}>()
);

// Get Device by Company
export const getDevicesByCompany = createAction(
    '[Devices] Get Devices by Company ',
    props<{companyId: string}>()
);

export const getDevicesByCompanySuccess = createAction(
    '[Devices] Get Devices by Company success', 
    props<{ devices: IDeviceDetailsResponse[] }>()
);

export const getDevicesByCompanyFailure = createAction(
    '[Devices] Get Devices by Company failure',
    props<{error: string}>()
);

// Get Device by id
export const getDeviceById = createAction(
    '[Devices] Get Device by id ',
    props<{id: string}>()
);

export const getDeviceByIdSuccess = createAction(
    '[Devices] Get Device by id success', 
    props<{ device: IDeviceDetailsResponse }>()
);

export const getDeviceByIdFailure = createAction(
    '[Devices] Get Device by id failure',
    props<{error: string}>()
);

// Create Devices
export const createDevice = createAction(
    '[Devices] Create Device',
    props<{ device: ICreateDeviceRequest }>()
);

export const createDeviceSuccess = createAction(
    '[Devices] Create Device success',
    props<{ device: IDeviceDetailsResponse }>()
);

export const createDeviceFailure = createAction(
    '[Devices] Create Device failure',
    props<{error: string}>()
);

// Update Devices 
export const updateDevice = createAction(
    '[Devices] Update Device',
    props<{ device: IUpdateDeviceRequest }>()
);

export const updateDeviceSuccess = createAction(
    '[Devices] Update Device success',
    props<{ device: IDeviceDetailsResponse }>()
);

export const updateDeviceFailure = createAction(
    '[Devices] Update Device failure',
    props<{error: string}>()
);

// Delete Device
export const deleteDevice = createAction(
    '[Device] Delete Device',
    props<{id: string}>()
);

export const deleteDeviceSuccess = createAction(
    '[Device] Delete Device success',
    props<{id: string}>()
);

export const deleteDeviceFailure = createAction(
    '[Device] Delete Device failure',
    props<{error: string}>()
);

// Import Device
export const importDevices = createAction(
    '[Device] Import Device',
    props<{formData: FormData}>()
);

export const importDevicesSuccess = createAction(
    '[Device] Import Device success',
    props<{importStatus: ImportStatusEnum}>()
);

export const importDevicesFailure = createAction(
    '[Device] Import Device failure',
    props<{error: string}>()
);